import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function TrialBalanceReport() {
  return <ReportForm reportAPI={ ReportAPI.TRIAL_BALANCE } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/TrialBalanceReport.js